import { useTranslation } from 'react-i18next';
import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  const { t } = useTranslation();

  return (
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
      {categories.map((cat) => (
        <a
          key={cat.key}
          href={cat.url}
          target="_blank"
          rel="noopener nofollow"
          className="group block bg-background-50 rounded-xl border border-background-200/70 overflow-hidden hover:border-primary-300 transition-all duration-300"
        >
          <div className="relative h-24 md:h-32 overflow-hidden">
            <img
              src={cat.img}
              alt={t(cat.nameKey)}
              className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
          </div>
          <div className="p-2.5 md:p-3 flex items-center gap-2">
            <i className={`${cat.icon} text-primary-500 text-sm md:text-base flex-shrink-0`}></i>
            <span className="text-xs md:text-sm font-medium text-foreground-700 group-hover:text-primary-700 transition-colors leading-tight">
              {t(cat.nameKey)}
            </span>
          </div>
        </a>
      ))}
    </div>
  );
}